module.exports = __webpack_public_path__ + "img/icon-logo.e4b2eaa8.svg";